interface Props {
  color?: string
  width?: number
  height?: number
}

export const FacebookIcon = ({ color = '#6F6F6F', width = 22, height = 22 }: Props) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M22 11C22 4.92487 17.0751 0 11 0C4.92487 0 0 4.92487 0 11C0 16.4905 4.0226 21.0408 9.28125 21.866V14.1797H6.48828V11H9.28125V8.5765C9.28125 5.81953 10.9244 4.29688 13.4356 4.29688C14.6388 4.29688 15.8984 4.51172 15.8984 4.51172V7.21875H14.512C13.146 7.21875 12.7188 8.06623 12.7188 8.93711V11H15.7695L15.282 14.1797H12.7188V21.866C17.9774 21.0408 22 16.4905 22 11Z"
        fill={color}
      />
    </svg>
  )
}
